import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Button, Col, Image, Row } from "react-bootstrap";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import React from "react";

export const NavBar = () => {
  const [activeKey, setActiveKey] = useState("/");

  const location = useLocation();
  React.useEffect(() => {
    // runs on location, i.e. route, change
    // console.log("handle route change here", location);
    setActiveKey(location.pathname);
  }, [location]);

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "auto",
      /* you can also use 'auto' behaviour 
           in place of 'smooth' */
    });
  };

  return (
    <Navbar expand="lg" variant="light">
      <Container fluid style={{paddingLeft: 50, paddingRight: 50}}>
        <Navbar.Brand as={Link} to="/" style={{ fontSize: 30, fontWeight: "bold" }}>
          PARSO
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav
            activeKey={activeKey}
            onSelect={(key, event) => setActiveKey(key as string)}
            className="ms-auto justify-content-end"
            variant="underline"
            style={{
              alignItems: "baseline",
            }}
          >
            <Nav.Link as={Link} to="/" eventKey="/">
              Home
            </Nav.Link>
            <Nav.Link as={Link} to="/download" eventKey="/download">
              Download
            </Nav.Link>
            <Nav.Link as={Link} to="/publications" eventKey="/publications">
              Publications
            </Nav.Link>
            <Nav.Link as={Link} to="/documentation" eventKey="/documentation">
              Documentation
            </Nav.Link>
            <Button variant="outline-dark" onClick={scrollToBottom}>
              Contact
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>


  );
};
